import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LoaderInterceptor } from '@pulse-front/core/interceptors/loader.interceptor';
import { TokenBackOfficeInterceptor } from '@pulse-front/core/interceptors/token.interceptor.backoffice';

import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { appRoutes } from './app.routes';

import { UiModule } from '@pulse-front/ui/src';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { ClientListComponent } from './features/clients/client-list/client-list.component';

import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { LoginComponent } from './features/auth/login/login.component';
import { AnalyticsComponent } from './features/analytics/analytics.component';
import { ExportConfirmDialogComponent } from './features/analytics/export-confirm-dialog/export-confirm-dialog.component';
import { ExportListComponent } from './features/exports/export-list/export-list.component';
import { CalendarModule } from 'primeng/calendar';

@NgModule({
  declarations: [
    AppComponent,
    ClientListComponent,
    MainLayoutComponent,
    LoginComponent,
    AnalyticsComponent,
    ExportConfirmDialogComponent,
    ExportListComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    UiModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    CalendarModule,
    RouterModule.forRoot(appRoutes, { initialNavigation: 'enabledBlocking' }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: TokenBackOfficeInterceptor,
    },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }